import React from 'react';
import cn from 'classnames';
import styles from './index.module.less'
import type { IProduct } from 'base/interfaces/product';
import { ListProductProps } from '@base/snippets/ListProduct';
import { useStore, observer } from 'base/store';

type IProps = {
    className?: string;
    product: IProduct;
    listConfig: ListProductProps['listConfig'];
}

const ListProductFlashsaleProgress: React.FC<IProps> = (props) => {
    const { userStore } = useStore();
    if ( !userStore.isInfoLoaded() || userStore.isDealer()) {
        return null;
    }

    const {
        className = '',
        product,
        listConfig
    } = props

    const {
        flashSale
    } = listConfig || {}

    const {
        showType = 'default',
    } = flashSale || {}

    const isSimpleType = showType === 'simple'

    const { flashSale: { percent, progressBarText } } = product;

    return (
        <div
            className={cn(
                [isSimpleType ? 'simple-progress-wrap' : 'progress-wrap'],
                className,
                [isSimpleType ? styles['simple-progress-wrap'] : styles['progress-wrap']],
            )}
        >
            <div className={cn('bg', styles.bg)}>
                {isSimpleType ? (

                    <div className={cn('progress-bar', styles['progress-bar'])}
                         style={{
                             width: `${+percent * 100}%` || '100%'
                         }}
                    />

                ) : (
                    <>
                        <div className={cn('progress-bar', styles['progress-bar'])}
                             style={{
                                 width: `${+percent * 100}%` || '100%'
                             }}
                        >
                            <div className={cn('sub-progress-bar', styles['sub-progress-bar'])}/>
                        </div>

                        <span className={cn('text', styles.text)}>
                            {progressBarText}
                        </span>
                    </>
                )}
            </div>
        </div>
    )
};

export default observer(ListProductFlashsaleProgress)